import Swal from "sweetalert2";

export const showDefaultAlert = (errorIcon, errorTitle, errorMessage) => {
  Swal.fire({
    icon: errorIcon,
    title: errorTitle,
    text: errorMessage,
  });
};

export const showConfirmationAlert = ({ confirmationMessage, onConfirm, onCancel }) => {
  Swal.fire({
    icon: 'warning',
    title: 'Confirmation',
    text: confirmationMessage,
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel',
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    } else {
      onCancel();
    }
  });
};

// Helper function for success messages
export const showSuccess = (message) => {
  Swal.fire({
    icon: 'success',
    title: 'Success',
    text: message,
    timer: 2000,
    showConfirmButton: false,
  });
};

// Helper function for error messages
export const showError = (message) => {
  Swal.fire({
    icon: 'error',
    title: 'Error',
    text: message,
  });
};